import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';

const extra = createReducer(
  { list: [], loading: false },
  {
    [ActionTypes.EXTRA_INSTALL_VOUCHER_VALIDATE_INIT]: (state, { payload }) => ({
      ...state,
      loading: false,
      list: [payload]
    }),
    [ActionTypes.EXTRA_INSTALL_VOUCHER_VALIDATE_REQUEST]: state => {
      return { ...state, loading: true };
    },
    [ActionTypes.EXTRA_INSTALL_VOUCHER_VALIDATE_SUCCESS]: (state, { payload }) => ({
      ...state,
      list: state.list.concat(payload)
    }),
    [ActionTypes.EXTRA_INSTALL_VOUCHER_VALIDATE_DONE]: state => {
      return { ...state, loading: false };
    },
    [ActionTypes.EXTRA_INSTALL_VOUCHER_REMOVE_SUCCESS]: (state, { payload }) => ({
      ...state,
      list: state.list.filter(e => e.voucher !== payload)
    })
  }
);

export default extra;
